export class ClientLocation {
    constructor(longitude, latitude) {
        this.Longitude = longitude;
        this.Latitude = latitude;
    }

    // will return non-numeric value if non-numeric value is entered
    get RoundedLongitude() {
        if (this.Longitude !== "" && this.Longitude !== null && !isNaN(this.Longitude)) {
            return ClientLocation.roundGeoToSignificantDigits(parseFloat(this.Longitude));
        } else {
            return this.Longitude !== null ? this.Longitude : "";
        }
    }

    // will return non-numeric value if non-numeric value is entered
    get RoundedLatitude() {
        if (this.Latitude !== "" && this.Latitude !== null && !isNaN(this.Latitude)) {
            return ClientLocation.roundGeoToSignificantDigits(parseFloat(this.Latitude));
        } else {
            return this.Latitude != null ? this.Latitude : "";
        }
    }

    // True if both Latitude and Longitude have numeric values
    get isFullyDefined() {
        return (
            !isNaN(this.Latitude) &&
            !isNaN(this.Longitude) &&
            this.RoundedLongitude !== "" &&
            this.RoundedLatitude !== ""
        );
    }

    // True if both Latitude and Longitude are empty
    get isEmpty() {
        return (this.Longitude === "" || this.Longitude === null) && (this.Latitude === "" || this.Latitude === null);
    }

    // True if both Latitude and Longitude have values within the valid range
    get isValid() {
        return (
            this.isFullyDefined &&
            this.RoundedLongitude >= -180 &&
            this.RoundedLongitude <= 180 &&
            this.RoundedLatitude >= -90 &&
            this.RoundedLatitude <= 90
        );
    }

    /**
     * Handles converting a decimal to the significant digits that make sense for a geographic coordinate.
     * @param {Number} geoDecimal Number to round
     * @returns Number rounded to up to 8 decimal places
     */
    static roundGeoToSignificantDigits(geoDecimal) {
        return +(Math.round(geoDecimal + "e+8") + "e-8");
    }

    /**
     * Initialize an instance of this ClientLocation from a ClientLocation-shaped string produced by
     * the server when loading saved data or the client when editing the project
     * The shape produced by the server is in this format: "POINT(Longitiude Latitude)"
     * The shape produced by the client in this format: "Longitude Latitude"
     * @param {string} stringLocation
     */
    static fromServerString(stringLocation) {
        // add split and null handling
        let longString = null;
        let latString = null;

        if (stringLocation) {
            stringLocation = stringLocation.replace("POINT(", "").replace(")", "");
            longString = stringLocation.split(" ")[0];
            latString = stringLocation.split(" ")[1];
        }
        const clientLocation = new ClientLocation(longString, latString);
        return clientLocation;
    }

    /**
     * Return a string representation of the location formatted to match the server
     */
    toServerString() {
        if (this.isEmpty) {
            return "";
        }
        return "POINT(" + this.RoundedLongitude + " " + this.RoundedLatitude + ")";
    }

    /**
     * @returns An array of the form [Longitude, Latitude] that can be used to create an Azure Maps point
     */
    toAzurePointArray() {
        return this.isFullyDefined ? [this.RoundedLongitude, this.RoundedLatitude] : null;
    }

    /**
     * Return a clone of the ClientLocation object on which this method was called
     */
    clone() {
        return new ClientLocation(this.Longitude, this.Latitude);
    }

    isEquivalent(otherLocation) {
        return (
            this.RoundedLongitude === otherLocation?.RoundedLongitude &&
            this.RoundedLatitude === otherLocation?.RoundedLatitude
        );
    }
}
